module.exports = __webpack_public_path__ + "static/media/act_logo.8773dc1d.webp";